var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 498,
    viewBox: "0 0 498 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.73 17.8411C455.937 -5.95188 417.227 -5.94218 393.453 17.8411L55.3944 355.91C54.9418 356.362 49.8438 361.663 48.5232 364.632L1.70827 469.807C-1.6166 477.273 0.00138092 486.015 5.78314 491.79C9.5606 495.566 14.6101 497.57 19.747 497.57C22.4544 497.57 25.1812 497.011 27.7642 495.862L132.941 449.047C135.899 447.729 141.208 442.63 141.663 442.177L479.73 104.12C491.257 92.5934 497.608 77.2718 497.608 60.9756C497.608 44.6809 491.257 29.3561 479.73 17.8411ZM451.822 76.2018L113.753 414.27C113.697 414.329 113.665 414.397 113.61 414.443L58.6708 438.901L83.1281 383.964C83.1766 383.905 83.2429 383.875 83.301 383.818L421.362 45.751C429.505 37.6061 443.698 37.6158 451.824 45.759C455.894 49.8161 458.136 55.2229 458.136 60.9756C458.136 66.7282 455.891 72.1334 451.822 76.2018Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.5e1c8901064e263b9e7a461154cc4508.svg";
export { ForwardRef as ReactComponent };